/* Office directory data and nearby/inside queries; geocoding comes from ./geocode. */
import { agency } from '../api';
import { getGeoLocation } from '../utility';
let offices;

export { getGeoCode, geocodePlace } from './geocode';
export const getAgenciesInside = agency.getAgenciesInside;
export async function getAgenciesNearby(keyword, name) {
  const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
  return agency.getAgenciesNearBy('POINT(' + GeoLocation_Longitude + ' ' + GeoLocation_Latitude + ')', keyword, name);
}

// export async function getAllOffices() {
//   const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
//   if (!offices) {
//     offices = agency.getAgenciesNearBy('POINT(' + GeoLocation_Longitude + ' ' + GeoLocation_Latitude + ')','','');
//   }
//   return offices;
// }

export async function getAllOffices() {
  if (!offices) {
    offices = agency.getAllAgencys();
  }
  return offices;
}
